
export interface NetworkConnectionState {
  isConnected: boolean;
}

export const defaultNetworkConnectionState: NetworkConnectionState = {
  isConnected: true
};

